















import { Component, Prop, VModel, Vue, Watch } from 'vue-property-decorator';
import { dateTimeToUtc, dateToInputDate, dateToInputTime } from "@/utils/date-utils";

@Component export default class extends Vue {
    @VModel({ type: Number }) dateMillis!: number

    @Prop() dateId!: string
    @Prop() dateLabel!: string
    @Prop() dateDescription!: string

    @Prop() timeId!: string
    @Prop() timeLabel!: string
    @Prop() timeDescription!: string

    @Prop() timeZone!: string

    date = ''
    time = ''

    created() {
        this.onValueChanged()
    }

    @Watch("date") onDateChanged() {
        this.dateMillis = dateTimeToUtc(this.dateTime, this.timeZone)
    }

    @Watch("time") onTimeChanged() {
        this.dateMillis = dateTimeToUtc(this.dateTime, this.timeZone)
    }

    get dateTime(): string {
        return this.date + " " + this.time
    }

    onValueChanged() {
        if (!Number.isNaN(this.dateMillis)) {
            const date = new Date(this.dateMillis);
            this.date = dateToInputDate(date, this.timeZone)
            this.time = dateToInputTime(date, this.timeZone)
        }
    }

    get dateInput(): HTMLInputElement {
        return ((this.$refs.date as Vue).$el) as HTMLInputElement
    }

    get timeInput(): HTMLInputElement {
        return ((this.$refs.time as Vue).$el) as HTMLInputElement
    }

    checkValidity(): boolean {
        return this.dateInput.checkValidity() && this.timeInput.checkValidity()
    }

    reportValidity() {
        if (!this.dateInput.checkValidity()) {
            this.dateInput.reportValidity()
        } else {
            this.timeInput.reportValidity()
        }
    }
}
